import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import useAddress from '@hooks/useAddress'
import useAgencySelector from '@hooks/useAgencySelector'
import useGeoCountries from '@hooks/useGeoCountries'

import type { UseAddressesPayload } from '@hooks/useAddresses'

import ShippingAddress from './ShippingAddressListItem'

interface ShippingAddressesProps {
  useAddressesPayload: UseAddressesPayload,
}

const ShippingAddresses = (props: ShippingAddressesProps) => {
  const { useAddressesPayload } = props

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAddresses,
    filteredAddressesCount,
    hasFilteredAddresses,
    loading,
  } = useAddressesPayload

  const { defaultGeoCountry } = useGeoCountries()

  const { selectedAgency, selectedAgencyId } = useAgencySelector()

  const initAddress = {
    geo_country_id: selectedAgency.geo_country_id || defaultGeoCountry?.id,
    owner_id: selectedAgencyId,
    owner_type: 'Agency',
  }

  const {
    callbacks: { createOrEditAddress },
  } = useAddress(initAddress)

  return (
    <DashboardModule
      loading={loading}
      title="Shipping Address"
    >
      <Box flexDirection="column">
        {!loading && !hasFilteredAddresses && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Addresses present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please add a Shipping Address
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredAddresses && (
          <DashboardModule.ScrollableSection>
            {filteredAddresses.map(address => (
              <ShippingAddress
                key={address.id}
                address={address}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAddressesCount}
          loading={loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditAddress()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Address
          </Button>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

export default ShippingAddresses
